import { useEffect, useState } from 'react';
import axios from 'axios';
import { BiDish, BiSolidDish } from "react-icons/bi";
import defaultImage from '../../../utils/DefaultImage';
import TableLoader from '../../../utils/TableLoader';
import PaginationComponent from '../../../utils/PaginationComponent';

const MenuDishList = (props) => {
    const {
        handleCheckboxChange,
        selectedDishes,
        setSelectedDishes
    } = props;

    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    const RestId = localStorage.getItem("currentRestId");
    const token = localStorage.getItem("token");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [dishListData, setDishListData] = useState([]);
    // const [selectedDishes, setSelectedDishes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;

    const getDishListData = async () => {
        setIsLoading(true);
        try {
            let params;
            params = {
                pageNumber: page,
                size: rowsPerPage,
            };
            const response = await axios.get(`${apiUrl}/api/v1/restaurants/${RestId}/dishes`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                params,
            });

            const data = response?.data;
            setDishListData(data?.data);
            setTotalPages(data?.total);
        } catch (error) {
            console.error('Error fetching order data:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getDishListData();
    }, [page, rowsPerPage])

    // const handleCheckboxChange = (dish) => {
    //     setSelectedDishes((prevSelected) => {
    //         const isAlreadySelected = prevSelected.some((selectedDish) => selectedDish.id === dish.id);

    //         if (isAlreadySelected) {
    //             return prevSelected.filter((selectedDish) => selectedDish.id !== dish.id);
    //         } else {
    //             const selectedDishData = {
    //                 id: dish.id,
    //                 full_price: dish.full_price,
    //                 half_price: dish.half_price,
    //                 is_option_to_be_full_dish: dish.is_option_to_be_full_dish ? 1 : 0, 
    //                 is_option_to_be_half_dish: dish.is_option_to_be_half_dish ? 1 : 0,  
    //             };
    //             return [...prevSelected, selectedDishData]; 
    //         }
    //     });
    // };


    const handlePriceChange = (id, type, value) => {
        if (!/^\d*\.?\d{0,2}$/.test(value)) {
            return;
        }

        setDishListData((prevDishes) =>
            prevDishes.map((item) =>
                item.id === id ? { ...item, [type]: value } : item
            )
        );

        setSelectedDishes((prevSelected) =>
            prevSelected.map((selectedDish) =>
                selectedDish.id === id ? { ...selectedDish, [type]: value } : selectedDish
            )
        );
    };

    const handlePriceChangeOld = (id, type, value) => {
        setDishListData((prevDishes) =>
            prevDishes.map((item) =>
                item.id === id ? { ...item, [type]: value } : item
            )
        );

        setSelectedDishes((prevSelected) =>
            prevSelected.map((selectedDish) =>
                selectedDish.id === id ? { ...selectedDish, [type]: value } : selectedDish
            )
        );
    };

    const handleOnFullPrice = (id) => {
        setDishListData((prevDishes) =>
            prevDishes.map((item) =>
                item.id === id
                    ? {
                        ...item,
                        is_option_to_be_full_dish: !item.is_option_to_be_full_dish,
                        // full_price: !item.is_option_to_be_full_dish ? "" : item.full_price ?? "0.00",
                    }
                    : item
            )
        );
        setSelectedDishes((prevSelected) =>
            prevSelected.map((selectedDish) =>
                selectedDish.id === id
                    ? {
                        ...selectedDish,
                        //   is_option_to_be_full_dish: !selectedDish.is_option_to_be_full_dish,
                        is_option_to_be_full_dish: selectedDish.is_option_to_be_full_dish ? 0 : 1,
                        //   full_price: selectedDish.is_option_to_be_full_dish ? "" : selectedDish.full_price || "",
                    }
                    : selectedDish
            )
        );
    };

    const handleOnHalfPrice = (id) => {
        setDishListData((prevDishes) =>
            prevDishes.map((item) =>
                item.id === id
                    ? {
                        ...item,
                        is_option_to_be_half_dish: !item.is_option_to_be_half_dish,
                        // half_price: !item.is_option_to_be_half_dish ? "" : item.half_price ?? "0.00",
                    }
                    : item
            )
        );

        setSelectedDishes((prevSelected) =>
            prevSelected.map((selectedDish) =>
                selectedDish.id === id
                    ? {
                        ...selectedDish,
                        //   is_option_to_be_half_dish: !selectedDish.is_option_to_be_half_dish,
                        is_option_to_be_half_dish: selectedDish.is_option_to_be_half_dish ? 0 : 1,
                        //   full_price: selectedDish.is_option_to_be_full_dish ? "" : selectedDish.full_price || "",
                    }
                    : selectedDish
            )
        );
    };


    // const handleOnFullPrice1 = (id) => {
    //     setDishListData((prevDishes) =>
    //         prevDishes.map((item) =>
    //             item.id === id
    //                 ? {
    //                       ...item,
    //                       is_option_to_be_full_dish: item.is_option_to_be_full_dish ? 0 : 1, // Toggle between 0 and 1
    //                       full_price: item.is_option_to_be_full_dish ? "" : item.full_price ?? "0.00", // Reset full price if disabled
    //                   }
    //                 : item
    //         )
    //     );

    //     setSelectedDishes((prevSelected) =>
    //         prevSelected.map((selectedDish) =>
    //             selectedDish.id === id
    //                 ? {
    //                       ...selectedDish,
    //                       is_option_to_be_full_dish: selectedDish.is_option_to_be_full_dish ? 0 : 1, // Toggle between 0 and 1
    //                   }
    //                 : selectedDish
    //         )
    //     );
    // };

    // const handleOnHalfPrice1 = (id) => {
    //     setDishListData((prevDishes) =>
    //         prevDishes.map((item) =>
    //             item.id === id
    //                 ? {
    //                       ...item,
    //                       is_option_to_be_half_dish: item.is_option_to_be_half_dish ? 0 : 1, // Toggle between 0 and 1
    //                       half_price: item.is_option_to_be_half_dish ? "" : item.half_price ?? "0.00", // Reset half price if disabled
    //                   }
    //                 : item
    //         )
    //     );

    //     setSelectedDishes((prevSelected) =>
    //         prevSelected.map((selectedDish) =>
    //             selectedDish.id === id
    //                 ? {
    //                       ...selectedDish,
    //                       is_option_to_be_half_dish: selectedDish.is_option_to_be_half_dish ? 0 : 1, // Toggle between 0 and 1
    //                   }
    //                 : selectedDish
    //         )
    //     );
    // };


    return (
        <>
            <div className="wine-main-stock w-auto h-auto bg-[#F8F8F8] border-[1.5px] border-[#8B24332B] text-[#303030] pt-3 pb-0 px-6 rounded-xl shadow">
                <table className="w-full text-left ristoranti_table">
                    <thead>
                        <tr className="border-b ">
                            <th className="pb-3 pr-2 text-left poppins-medium"></th>
                            <th className="pb-3 pr-2 text-left poppins-medium">Immagine</th>
                            <th className="pb-3 px-2 text-left poppins-medium">Nome del piatto</th>
                            <th className="pb-3 px-2 text-left poppins-medium">Descrizione</th>
                            <th className="pb-3 px-2 text-left poppins-medium">Mostra Prezzi</th>
                            <th className="pb-3 px-2 text-left poppins-medium">Prezzo Intero</th>
                            <th className="pb-3 px-2 text-left poppins-medium">Prezzo Mezza Porzione</th>
                        </tr>
                    </thead>
                    {isLoading ? (
                        <TableLoader />
                    ) : (
                        <tbody>
                            {dishListData && dishListData?.length > 0 ? (
                                dishListData?.map((item, index) => (
                                    <tr key={index} className="border-b xxl:text-lg text-sm">
                                        <td className="py-4 text-left poppins-regular">
                                            <input
                                                type="checkbox"
                                                className="h-4 w-4 border rounded-md accent-[#8B2433] mr-2 poppins-regular"
                                                checked={selectedDishes.some((selectedDish) => selectedDish.id === item.id)}
                                                onChange={() => handleCheckboxChange(item)}
                                            />
                                        </td>
                                        <td className="pr-2 py-4">
                                            <div className="thumbnail_image rounded-lg w-[50px] h-[60px] p-1 flex align-center justify-center">
                                                <img
                                                    className="w-10 h-10 rounded-full"
                                                    src={
                                                        item?.picture && item?.picture !== ""
                                                            ? `${logoUrl}/${item.picture}`
                                                            : defaultImage
                                                    }
                                                />
                                            </div>
                                        </td>
                                        <td className="py-4 px-2 text-left poppins-regular">{item?.name}</td>
                                        <td className="py-4 px-2 text-justify poppins-regular xl:h-auto h-[100px] overflow-y-auto">
                                            {item?.description}
                                        </td>
                                        <td className="py-4 px-2 text-left poppins-regular">
                                            <div className="flex flex-col items-center justify-center gap-2">
                                                {/* Full Price Checkbox */}
                                                <div className="flex items-center gap-2">
                                                    <div className="svg-icon h-[15.69px] w-[15.69px] bg-white">
                                                        <BiSolidDish className="w-4 h-4" color="#303030" />
                                                    </div>
                                                    <input
                                                        type="checkbox"
                                                        className="accent-[#8B2433] w-4 h-4 rounded-md"
                                                        checked={item.is_option_to_be_full_dish || false}
                                                        onChange={() => handleOnFullPrice(item.id)}
                                                    />
                                                </div>

                                                {/* Half Price Checkbox */}
                                                <div className="flex items-center gap-2">
                                                    <div className="svg-icon h-[15px] w-[15px] bg-white">
                                                        <BiDish className="w-4 h-4" color="#303030" />
                                                    </div>
                                                    <input
                                                        type="checkbox"
                                                        className="accent-[#8B2433] w-4 h-4 rounded-md"
                                                        checked={item.is_option_to_be_half_dish || false}
                                                        onChange={() => handleOnHalfPrice(item.id)}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                        <td className="py-4 px-2 text-left poppins-regular">

                                            <input
                                                type="text"
                                                placeholder="Scrivi qui"
                                                className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                                                value={item.full_price || ""}
                                                onChange={(e) => handlePriceChange(item.id, "full_price", e.target.value)}
                                            />
                                            {/* {item.is_option_to_be_full_dish ? (
                                                <input
                                                    type="text"
                                                    placeholder="Scrivi qui"
                                                    className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                                                    value={item.full_price || ""}
                                                    onChange={(e) => handlePriceChange(item.id, "full_price", e.target.value)}
                                                />
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                                                    value="0.00"
                                                    readOnly
                                                    style={{ cursor: "not-allowed" }}
                                                />
                                            )} */}
                                        </td>
                                        <td className="py-4 px-2 text-left poppins-regular">

                                            <input
                                                type="text"
                                                placeholder="Scrivi qui"
                                                className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                                                value={item.half_price || ""}
                                                onChange={(e) => handlePriceChange(item.id, "half_price", e.target.value)}
                                            />

                                            {/* {item.is_option_to_be_half_dish ? (
                                                <input
                                                    type="text"
                                                    placeholder="Scrivi qui"
                                                    className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                                                    value={item.half_price || ""}
                                                    onChange={(e) => handlePriceChange(item.id, "half_price", e.target.value)}
                                                />
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                                                    value="0.00"
                                                    readOnly
                                                    style={{ cursor: "not-allowed" }}
                                                />
                                            )} */}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="py-4 text-center">
                                        No dishes found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>
            </div>

            {dishListData && dishListData?.length > 0 && (
                <PaginationComponent
                    page={page}
                    totalPages={totalPages}
                    rowsPerPage={rowsPerPage}
                    setPage={setPage}
                    setRowsPerPage={setRowsPerPage}
                />
            )}
        </>
    )
}

export default MenuDishList;